import React from "react";
import classes from "../styles/style.module.css";
import LeftArrow from "../../../assets/images/Roshana/leftArrow.svg";

const RoshanaButton = ({ text, color, handleClick, styles }) => {
  return (
    <button
      className={`${classes.customButton} ${
        color === "primary"
          ? classes.primaryColorButton
          : color === "red"
          ? classes.redColorButton
          : classes.secondaryColorButton
      }`}
      style={{ ...styles }}
      onClick={handleClick}
    >
      <div className={classes.buttonTextContainer}>
        {text}
        <img src={LeftArrow} alt="leftArrow" />
      </div>
    </button>
  );
};

export default RoshanaButton;
